module.exports = __webpack_public_path__ + "img/provider12.152857e4.png";